import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ContributionRule  {
    _originalTypeClassName = "zERP.BO.ContributionRule";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ContributionRule.translate = translateService;
}
this.SalaryPeriods = [];
this.Id = null;
this.Code = null;
this.Name = null;
this.Description = null;
this.OfficeType = null;
this.ForHealthSector = false;
this.ForMainPension = false;
this.ForSupplementaryPension = false;
this.ForWelfare = false;
this.ForCoPayments = false;
this.IsActive = false;
this.SICPackageType = null;
this.KaeCodeEmployer = null;
this.EapCodeEmployer = null;
this.EapCode = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
Name:any;
Description:any;
OfficeType:any;
ForHealthSector:any;
ForMainPension:any;
ForSupplementaryPension:any;
ForWelfare:any;
ForCoPayments:any;
IsActive:any;
SICPackageType:any;
KaeCodeEmployer:any;
EapCodeEmployer:any;
EapCode:any;
CalculationScale:any;
EmployeeData:any;
EmployerData:any;
SalaryPeriods:any;
AccountingConfig:any;
static setCalculationScale = ($this, value) => {
var oldValue = $this.CalculationScale;
$this.CalculationScale = value;
if (value != null) {
}
}
static setEmployeeData = ($this, value) => {
var oldValue = $this.EmployeeData;
$this.EmployeeData = value;
if (value != null) {
}
}
static setEmployerData = ($this, value) => {
var oldValue = $this.EmployerData;
$this.EmployerData = value;
if (value != null) {
}
}
static setSalaryPeriods = ($this, items) => {
                if (items == null) items = [];
                if ($this.SalaryPeriods == null) $this.SalaryPeriods = [];

                const copyItems = Common.cloneObject(items);

                while ($this.SalaryPeriods.length > 0) {
                    Domain.ContributionRule.removeSalaryPeriods($this, $this.SalaryPeriods[0]);
                }

                Domain.ContributionRule.addManySalaryPeriods($this, copyItems);
            }
static addManySalaryPeriods = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ContributionRule.addSalaryPeriods($this, items[i]);
                }
            }
static addSalaryPeriods = ($this, item) => {
                if ($this.SalaryPeriods == null) $this.SalaryPeriods = [];
                if (item == null || $this.SalaryPeriods.indexOf(item) > -1) return;
                $this.SalaryPeriods.push(item);
}
static addRangeSalaryPeriods = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ContributionRule.addSalaryPeriods($this, item));
            }
static removeSalaryPeriods = ($this, item) => {
                if ($this == null || $this.SalaryPeriods == null || $this.SalaryPeriods.indexOf(item) === -1) return;
                var _index = $this.SalaryPeriods.indexOf(item);
                $this.SalaryPeriods.splice(_index, 1);
}
static clearSalaryPeriods = ($this) => { $this.SalaryPeriods = null; }
static setAccountingConfig = ($this, value) => {
var oldValue = $this.AccountingConfig;
$this.AccountingConfig = value;
if (value != null) {
}
}

static CalculateRate($this: any, data: any,coveragePackageVersion: any): any{switch (data?.ValueCalculationType) {case Domain.ContributionRuleValueUpdateType.CoveragePackage:
{
return (data?.ForEmployee ? coveragePackageVersion?.EmployeeRate : coveragePackageVersion?.EmpoyerRate);}
}
throw Error("Contribution update value type '" + data?.ValueCalculationType + "' is not implemented yet");
}
static CreateNew(): any{let rule = new Domain.ContributionRule();
Domain.ContributionRule.setEmployeeData(rule, new Domain.ContributionRuleCalculation());
rule.EmployeeData.ForEmployee = true;
Domain.ContributionRuleCalculation.setSubsidyRules(rule.EmployeeData, new Domain.ContributionRuleCalculationSubsidy());
Domain.ContributionRule.setEmployerData(rule, new Domain.ContributionRuleCalculation());
Domain.ContributionRuleCalculation.setSubsidyRules(rule.EmployerData, new Domain.ContributionRuleCalculationSubsidy());
return rule;
}
static FilterSalaries($this: any, data: any,salaries: any): any{switch (data?.CalculationBase) {case Domain.ContributionRuleCalculationBase.AllSalaries:
{
for (let _isalary = 0; _isalary < (salaries == null ? 0 : salaries.length); _isalary++) {let salary = salaries[_isalary];if (data?.ForEmployee) {salary.ForEmployee = true;}else {salary.ForEmployer = true;}}return;}
case Domain.ContributionRuleCalculationBase.SpecificSalaries:
{
for (let _isalary = 0; _isalary < (salaries == null ? 0 : salaries.length); _isalary++) {let salary = salaries[_isalary];if (data?.ForEmployee) {salary.ForEmployee = data?.CalculationSalaryRules?.linq?.any((s) => CLMS.Framework.Number.Equal(() => s.Id, () => salary.Salary.Id));}else {salary.ForEmployer = data?.CalculationSalaryRules?.linq?.any((s) => CLMS.Framework.Number.Equal(() => s.Id, () => salary.Salary.Id));}}return;}
}
throw Error("Ταμείο με βάση υπολογισμού '" + data?.CalculationBase + "' δεν υποστιρίζεται");
}
static GetClassName(): any{return CLMS.Framework.Utilities.ThrowException("StdLib.RuntimeType.Name()").Test;
}
static IsAvailable($this: any, calculation: any): any{if ($this?.IsActive != true) {return false;}
if (($this?.SalaryPeriods?.linq?.any() && !($this?.SalaryPeriods?.linq?.any((s) => s == calculation?.Type)))) {return false;}
return true;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}